
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.about-me-slice {

    display: block;

    padding-top: 1rem;

    padding-bottom: 1rem;

    font-family: var(--ff-display)
}

@media (min-width: 768px) {

    .about-me-slice {

        padding-top: 4rem;

        padding-bottom: 4rem
    }
}

.about-me-title {

    margin-bottom: 2rem
}

.about-me-heading {

    margin-bottom: 1.5rem
}

@media (min-width: 768px) {

    .about-me-content-section {

        display: flex
    }
}

.about-me-left-column {

    border-width: 0px;

    border-right-width: 1px
}

@media (min-width: 768px) {

    .about-me-left-column {

        width: 50%
    }

    .about-me-left-column {

        border-style: solid
    }

    .about-me-left-column {

        border-color: var(--neutral-gray-3)
    }

    .about-me-left-column {

        padding-right: 3.5rem
    }
}

.about-me-right-column {

    position: relative
}

@media (min-width: 768px) {

    .about-me-right-column {

        width: 50%
    }

    .about-me-right-column {

        padding-left: 3.5rem
    }
}

:host {

    display: block
}
`;